import { graphql } from "gatsby";
import React from "react";
import { AccordionItem } from "./AccordionItem";
import clsx from "clsx";
import { buildThemeClasses } from "@src/utils/theme";
import { useLiveUpdates } from "@src/hooks/useLiveUpdates";
import { IdTooltip } from "@src/components/elements/IdTooltip";
import { getContentfulPreviewPropsFn } from "@utils";

export function SectionAccordion({ entry: rawEntry }) {
  const entry = useLiveUpdates(rawEntry);
  const items = entry?.items ?? [];
  const getPreviewProps = getContentfulPreviewPropsFn(entry?.contentful_id);
  const [openAccordions, setOpenAccordions] = React.useState(
    items.filter((item) => item.isOpen).map((item) => item.contentful_id)
  );

  const title = entry?.title;

  const handleOpen = (id) => {
    setOpenAccordions((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };
  return (
    <section
      className={clsx("font-atkinson py-section", buildThemeClasses(entry?.customTheme))}
      id={entry?.contentful_id}
    >
      <IdTooltip id={entry?.contentful_id} />
      <div className="max-w-[768px] m-auto gap-5 md:gap-20">
        {title && (
          <h2
            className="text-rt-2m md:text-4xl my-6 font-medium text-center mt-0"
            {...getPreviewProps("title")}
          >
            {title}
          </h2>
        )}
        {items?.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <AccordionItem
              key={item.contentful_id}
              isOpen={openAccordions.includes(item.contentful_id)}
              setOpen={handleOpen}
              theme={entry.customTheme}
              entry={item}
              isLast={isLast}
            />
          );
        })}
      </div>
    </section>
  );
}

export const SectionAccordionFragment = graphql`
  fragment SectionAccordion on ContentfulSectionAccordion {
    __typename
    sys {
      id
    }
    contentful_id
    internalName
    title
    customTheme
    items {
      ...AccordionItem
    }
  }
`;
